<template>
    <div class="clocklogs-report">
        <div class="columns toolbar-box action-right">
            <div class="column is-3">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Clocklogs Report</span>
                        <a
                            href="#"
                            class="gear"
                            @click.prevent="isTableSettingsModalActive = true"
                        >
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                            v-model="filters.user_id"
                            :custom="{placeholder: 'Employee'}"
                            type="user"
                            @input="fetchPaginatedData(true)"
                    />
                </o-field>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <div class="field">
                    <datepicker v-model="filters.date"
                                input-class="input is-fullwidth"
                                placeholder="Date" :absolute="true"
                    />
                </div>
            </div>
        </div>
        <div class="columns toolbar-box action-right">
            <div class="column is-4-tablet is-2-desktop is-offset-3">
                <div class="field">
                    <datepicker v-model="filters.from"
                                input-class="input is-fullwidth"
                                placeholder="From" :absolute="true"
                    />
                </div>
            </div>
            <div class="column is-4-tablet is-2-desktop">
                <datepicker v-model="filters.to"
                            input-class="input is-fullwidth"
                            placeholder="To" :absolute="true"
                />
            </div>
            <div class="column is-2">
                <div class="field">
                    <p class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                </div>
            </div>
        </div>
        <br>
        <o-table
                class="fullwidth-table is-responsive is-responsive-desktop"

                v-if="isTableVisible"
                :data="paginatedData"

                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="false"
                :mobile-cards="table.mobileCards"
                :paginated="paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort="table.defaultSort"
                :loading="loading"
                :total="total"
                backend-sorting
                backend-pagination
                @page-change="onPageChange"
                @sort="onSort"
        >
            <template>
                <template>
                    <o-table-column
                            v-for="col in tableColumns"
                            #default="{ row }"
                            @click.native="openEditPunchesDatesModal(row)"
                            :field="col.field"
                            :label="col.label"
                            :sortable="col.sortable"
                    >
                        <span v-if="col.field === 'date'">{{ $filters.valueOrDefault($filters.date(row[col.field]),'-') }}</span>
                        <span v-else-if="col.field === 'punches'">
                            {{ punchesText(row) }}
                        </span>
                        <span v-else-if="col.field === 'status'">
                            {{ status(row) }}
                        </span>
                        <span v-else-if="col.field === 'total_hours'">
                            {{ totalHours(row) }}
                        </span>
                        <span v-else>
                            {{  $filters.valueOrDefault(row[col.field],'-') }}
                        </span>
                    </o-table-column>
                </template>
            </template>
          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isEditPunchesModalActive" has-modal-card @close="fetchPaginatedData">
            <edit-punches-dates-modal :clocklog="selectedItem"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Datepicker from './../../components/Datepicker'
    import Table from './../../mixins/Table'
    import EditPunchesDatesModal from './EditPunchesDatesModal'

    export default {
        mixins: [Table],
        components: {
            Datepicker,
            EditPunchesDatesModal,
        },
        computed: {
            ...mapGetters(['clocklog']),
            paginated() {
                return this.total > 10
            },
        },
        data() {
            return {
                filters: {
                    date: moment(new Date()).format('YYYY-MM-DD'),
                    from: null,
                    to: null,
                    user_id: null,
                },
                isEditPunchesModalActive: false,
                isTableSettingsModalActive: false,
                selectedItem: null,
                table: {
                    defaultSort: ['date', 'desc'],
                    perPage: 10,
                    perPageOptions: [5, 10, 15, 25, 50],
                },
                tableName: 'clocklogs',
            }
        },
        methods: {
            fetchData(params) {
                return axios.get(`/api/reports/clocklogs-report`, { params })
            },
            openEditPunchesDatesModal(item) {
                this.selectedItem = item
                this.isEditPunchesModalActive = true
            },
            punchesText(item) {
                const { clock_in, clock_out } = item
                const { time, valueOrDefault } = this.$filters
                const cin = !!clock_in ? time(clock_in) + '-IN' : ''
                const cout = !!clock_out ? time(clock_out) + '-OUT' : ''
                return valueOrDefault(`${cin} ${cout}`.trim(), '-')
            },
            status(item) {
                if(item.clock_in && item.clock_out){
                    return 'Punched out'
                }else if(item.clock_in) {
                    return 'Punched in'
                }
                return '-'
            },
            totalHours(item) {
                if(item.hasOwnProperty('total_hours') && item.total_hours !== null) {
                    return item.total_hours
                }
                return '-'
            },
        },
        mounted() {
            this.fetchPaginatedData()
        },
        watch: {
            clocklog() {
                this.fetchPaginatedData()
            },
            filters: {
                deep: true,
                handler() {
                    this.fetchPaginatedData()
                }
            },
        },
    }
</script>
<style>
    .clocklogs-report .table-wrapper {
        min-height: auto;
        margin-bottom: 54px
        }
</style>
